import Button from '@src/components/ui/atoms/button';
import Input from '@src/components/ui/atoms/input';
import authApi from '@src/services/api/auth';
import { ACCESS_TOKEN_KEY, setCookie } from '@src/services/storage/cookies';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  > div {
    width: 500px;
    margin: 0 auto;
    &:last-of-type {
      display: flex;
      justify-content: end;
      margin-top: 30px;
    }
  }
`;

const SignInWrap = styled.div`
  width: 500px;
  display: grid;
  grid-template-columns: 200px auto;
  gap: 10px 20px;
`;

export default function SignIn() {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      const { data } = await authApi.signIn({ id, password });
      if (data.id) {
        setCookie(ACCESS_TOKEN_KEY, { access: data.access_token });
        navigate('/schedule');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container>
      <SignInWrap>
        <span>ID</span>
        <div>
          <Input value={id} onChange={setId} name="id" />
        </div>
        <span>Password</span>
        <div>
          <Input value={password} onChange={setPassword} type="password" name="password" />
        </div>
      </SignInWrap>
      <div>
        <Button onClick={handleClick}>Sign in</Button>
      </div>
    </Container>
  );
}
